import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowRight, Zap } from 'lucide-react';
import { scrollToCheckout } from '../utils/scroll';
export const EliteEbooks = () => {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-dark text-white" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <div className="text-center mb-10" data-id="element-106">
          <h2 className="text-2xl sm:text-4xl font-serif font-bold text-gold-400 mb-3" data-id="element-107">
            ¿Querés el sistema COMPLETO?
          </h2>
          <p className="text-lg sm:text-2xl font-bold mb-3" data-id="element-108">
            Agregá los 2 Ebooks Elite y llevate todo por $29.990
          </p>
          <p className="text-base text-gray-300 max-w-2xl mx-auto" data-id="element-109">
            Donde el conocimiento se convierte en resultados diarios visibles y
            medibles.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-10" data-id="element-110">
          {/* Elite 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-2xl border border-gold-500/30 p-5 sm:p-6 relative overflow-hidden" data-id="element-111">
            <div className="absolute top-0 right-0 bg-gold-500 text-dark font-bold px-3 py-1 rounded-bl-xl text-xs flex items-center gap-1" data-id="element-112">
              <Star size={12} fill="currentColor" data-id="element-113" /> ELITE
            </div>
            <h3 className="text-lg sm:text-xl font-serif font-bold text-gold-400 mb-1 mt-2 flex items-center gap-2" data-id="element-114">
              <Star className="text-gold-400 shrink-0" fill="currentColor" size={20} data-id="element-115" />
              Agenda de Micro-Dosis
            </h3>
            <p className="text-base font-medium text-white mb-3" data-id="element-116">
              Lograste en 1 día lo que antes te llevaba 1 mes
            </p>

            <div className="space-y-2 mb-4" data-id="element-117">
              {['Fragmentación Atómica de Tareas', 'Cajón de Distracciones Integrado', 'Sistema de Tachado Dopamínico', 'Arquitectura de la Semana', 'Adaptación al Ciclo Menstrual', 'Todas las plantillas listas para usar'].map((item, i) => <div key={i} className="flex items-start gap-2 text-xs sm:text-sm text-gray-300" data-id="element-118">
                  <ArrowRight className="text-gold-500 shrink-0 mt-0.5" size={14} data-id="element-119" />
                  <span data-id="element-120">{item}</span>
                </div>)}
            </div>
            <div className="pt-3 border-t border-white/10 text-xs text-gray-400" data-id="element-121">
              Valor percibido:{' '}
              <span className="text-white font-bold" data-id="element-122">$24.990</span>
            </div>
          </motion.div>

          {/* Elite 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-2xl border border-gold-500/30 p-5 sm:p-6 relative overflow-hidden" data-id="element-123">
            <div className="absolute top-0 right-0 bg-gold-500 text-dark font-bold px-3 py-1 rounded-bl-xl text-xs flex items-center gap-1" data-id="element-124">
              <Star size={12} fill="currentColor" data-id="element-125" /> ELITE
            </div>
            <h3 className="text-lg sm:text-xl font-serif font-bold text-gold-400 mb-1 mt-2 flex items-center gap-2" data-id="element-126">
              <Star className="text-gold-400 shrink-0" fill="currentColor" size={20} data-id="element-127" />
              Freno de Emergencia
            </h3>
            <p className="text-base font-medium text-white mb-3" data-id="element-128">
              Dejá de tirar dinero en compras por impulso
            </p>

            <div className="space-y-2 mb-4" data-id="element-129">
              {['Los 5 Arquetipos de Gasto con TDAH', 'Presupuesto de 5 Categorías Pro-TDAH', 'Plan de Salida de Deudas', 'Registro de Ahorros por No Comprar', 'Todas las plantillas financieras'].map((item, i) => <div key={i} className="flex items-start gap-2 text-xs sm:text-sm text-gray-300" data-id="element-130">
                  <ArrowRight className="text-gold-500 shrink-0 mt-0.5" size={14} data-id="element-131" />
                  <span data-id="element-132">{item}</span>
                </div>)}
            </div>
            <div className="pt-3 border-t border-white/10 text-xs text-gray-400" data-id="element-133">
              Valor percibido:{' '}
              <span className="text-white font-bold" data-id="element-134">$24.990</span>
            </div>
          </motion.div>
        </div>

        {/* Persuasion callout */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-600 to-gold-400 rounded-2xl p-5 sm:p-6 text-center max-w-2xl mx-auto mb-8 shadow-xl shadow-gold-500/20 text-dark" data-id="element-135">
          <p className="text-base sm:text-lg font-bold mb-1 flex items-center justify-center gap-2" data-id="element-136">
            <Zap className="fill-current shrink-0" size={20} data-id="element-137" />
            Solo $10.000 más que el Base = $49.980 en valor extra.
          </p>
          <p className="text-lg sm:text-xl font-serif font-black italic" data-id="element-138">
            Es la decisión más obvia de esta página.
          </p>
        </motion.div>

        <div className="text-center" data-id="element-139">
          <button onClick={scrollToCheckout} className="group w-full sm:w-auto inline-flex items-center justify-center px-6 sm:px-8 py-4 text-base sm:text-lg font-bold text-dark transition-all duration-200 bg-gradient-to-r from-gold-400 to-gold-500 rounded-full hover:scale-105 shadow-xl shadow-gold-500/30 mb-4" data-id="element-140">
            🌟 QUIERO EL BUNDLE COMPLETO POR $29.990
          </button>
          <p className="text-sm text-gray-400" data-id="element-141">
            <button onClick={scrollToCheckout} className="hover:text-white underline transition-colors" data-id="element-142">
              O llevate solo el sistema base por $19.990 →
            </button>
          </p>
        </div>
      </div>
    </section>;
};